import {enqueueSnackbar} from "notistack";
import {generatePdfReport} from "../../../service/proposal.service";

export function generatePdf(selection:Record<string, boolean>, setSelection:(r:{}) => void, setPdfGenerating:(b:boolean) => void) {
    const selectedRows = [];
    for (let id in selection) {
        if (selection[id]) {
            selectedRows.push(id);
        }
    }
    if (!selectedRows.length) {
        enqueueSnackbar({ message: 'To generate PDF report please select proposal(s)', variant: 'info' })
        return
    }
    setPdfGenerating(true)
    generatePdfReport(selectedRows)
        .then(() => setSelection({}))
        .catch(() => enqueueSnackbar({ message: "Failed to generate PDF report", variant: 'error' }))
        .finally(() => setPdfGenerating(false));
}